import Marquee from "react-fast-marquee";
import { PARTNERS } from "../lib/data";

export const PartnerMarquee = () => (
  <section data-testid="partner-marquee" className="py-12 border-y border-[#E5DFD3] bg-[#F5F2EB] overflow-hidden">
    <p className="overline text-[#C19A6B] text-center mb-8">Trusted by leading developers</p>
    <Marquee speed={40} gradient gradientColor="#F5F2EB" gradientWidth={120} autoFill>
      {PARTNERS.map((p, i) => (
        <span
          key={i}
          className="font-serif-lux text-3xl md:text-4xl text-[#5C5C5C] mx-12 whitespace-nowrap"
        >
          {p}
          <span className="text-[#C19A6B] ml-12">◆</span>
        </span>
      ))}
    </Marquee>
  </section>
);
